import axios from 'axios'
import React, { lazy, useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './BlikPage.module.scss'

import { ReactComponent as BlikLogo } from '../../assets/images/blik.svg'; // Adjust the path accordingly
import PhoneLogo from '../../assets/images/phone.webp';
import { Environment } from "../../config/Environment";
import { sbankInvoiceStatuses } from "../FinishPage/FinishPage";
import { status } from "../../model/finishSagas/finishActions";
import {CooldownButton} from "./CooldownButton";

const apiURL = Environment.REACT_APP_API_URL ?? ''

const storeSetIsSubmitted = (invoiceId) => {
  localStorage.setItem('blik-summitted-invoice-' + invoiceId, true);
}

const storeGetIsSubmitted = (invoiceId) => {
  return localStorage.getItem('blik-summitted-invoice-' + invoiceId);
}

const formattedAmount = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
})

const RETRY_TIMEOUT = 120;

export const BlikPage = () => {
  const [searchParams] = useState(new URLSearchParams(window.location.search))
  const dispatch = useDispatch()
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [submitted, setSubmitted] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isCompleted, setIsCompleted] = useState(!!localStorage.getItem(`blik-is-completed-invoice-${searchParams.get('invoice_id')}`))
  const [isAlreadySubmittedError, setisAlreadySubmittedError] = useState(false)
  const inputRefs = useRef([]);
  const iframeUrlRef = useRef(null)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const [submitLimit, setSubmitLimit] = useState(0)
  const [submitCount, setSubmitCount] = useState(0)

  const [isRetryActive, setIsRetryActive] = useState(false)
  const [isRetrySuccess, setIsRetrySuccess] = useState(true)

  const [timeLeft, setTimeLeft] = useState(RETRY_TIMEOUT);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const id = setInterval(() => {
      setTimeLeft(t => t - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [timeLeft]);

  const [isStarted, setIsStarted] = useState(false)

  const [state, setState] = useState({})
  const finish = useSelector(state => state.finish)

  const fetchStatus = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const data = {}
    data.invoice_id = urlParams.get('invoice_id')
    data.product_id = urlParams.get('endpoint_id')
    data.merchant_id = urlParams.get('merchant_id')
    data.order = urlParams.get('order')
    data.currency = urlParams.get('currency')
    data.signature = urlParams.get('form_status_signature')
    dispatch(status(data))
  }, [])

  useEffect(() => {
    fetchStatus()
  }, [])

  useEffect(() => {
    if(finish.data) {
      const limit = Number(finish.data.form_submit_limit)
      const count = Number(finish.data.form_submitted)
      if(count >= limit) {
        // setIsSubmitted(true)
      }
      setTimeout(() => {
        setIsStarted(true)
      })
    }
  }, [finish.data])

  useEffect(() => {
    if (isCompleted) {
      localStorage.setItem(`blik-is-completed-invoice-${searchParams.get('invoice_id')}`, 'true');
    }
  }, [isCompleted]);

  useEffect(() => {
    if (!finish.data) {
      return
    }
    const limit = Number(finish.data.form_submit_limit)
    const count = Number(finish.data.form_submitted)
    setSubmitLimit(limit)
    setSubmitCount(count)
    if(count === 0) {
      return;
    }
    const {payment_status, error_url, finish_url, success_url} = finish.data
    if (success_url && payment_status === sbankInvoiceStatuses.COMPLETE) {
      document.location.href = success_url
      return
    }
    if (error_url && payment_status === sbankInvoiceStatuses.FAILED) {
      document.location.href = error_url
      return
    }
    if (finish_url && payment_status === sbankInvoiceStatuses.COMPLETE || payment_status === sbankInvoiceStatuses.FAILED) {
      document.location.href = finish_url
      return
    }
  }, [finish.data])

  useEffect(() => {
    if (isCompleted || isError) {
      const urlParams = new URLSearchParams(window.location.search);
      const data = {}
      data.invoice_id = urlParams.get('invoice_id')
      data.product_id = urlParams.get('endpoint_id')
      data.merchant_id = urlParams.get('merchant_id')
      data.order = urlParams.get('order')
      data.currency = urlParams.get('currency')
      data.signature = urlParams.get('form_status_signature')
      setState(data)
      dispatch(status(data))
    }
  }, [isCompleted, isError])

  useEffect(() => {
    const timer = setInterval(() => {
      if (finish && finish.status === sbankInvoiceStatuses.PENDING) {
        dispatch(status(state))
      }
    }, 5e3)
    return () => {
      clearInterval(timer)
    };
  }, [state, finish]);

  const urlSearchParams = useRef(new URLSearchParams(window.location.search))

  useEffect(() => {

    const urlParamsObj = new URLSearchParams(window.location.search);
    const urlParams = {}

    for (const key of urlParamsObj.keys()) {
      urlParams[key] = urlParamsObj.get(key)
    }
    if (storeGetIsSubmitted(urlParams['invoice_id']) && isCompleted) {
      setIsSubmitted(true)
    }
    if (isCompleted) {
      setIsSubmitted(true)
    }
  }, []);

  useEffect(() => {
    if (isSubmitted) {
      setSubmitted(true)
      const urlParams = new URLSearchParams(window.location.search);
      const data = {}
      data.invoice_id = urlParams.get('invoice_id')
      data.product_id = urlParams.get('endpoint_id')
      data.merchant_id = urlParams.get('merchant_id')
      data.order = urlParams.get('order')
      data.currency = urlParams.get('currency')
      data.signature = urlParams.get('form_status_signature')
      setState(data)
      dispatch(status(data))
    }
  }, [isSubmitted]);


  const canSubmit = () => {
    return !submitted && otp.join("").length === 6
  }

  // Handle OTP input (works for both desktop and mobile)
  const handleInput = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]$/.test(value)) {
      let newOtp = [...otp];

      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }

      // Auto submit if the last field is filled
      if (index === otp.length - 1) {
        // handleSubmit(newOtp);
      }
    } else {
      e.target.value = ""; // Clear the input if the value is invalid
    }
  };

  // Handle backspace for desktop (keydown)
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      let newOtp = [...otp];

      // If the current field has a value, clear it
      if (otp[index] !== "") {
        newOtp[index] = "";
        setOtp(newOtp);
      }
      // If the current field is empty, move to the previous field and clear that
      else if (index > 0) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    } else if (e.key === "Enter") {
      if (canSubmit()) {
        handleSubmit(otp)
      }
    } else if (e.target.value != "") {
      e.target.value = ""
      handleInput(e, index)
    }
  };

  // Handle backspace for mobile (input event)
  const handleBackspaceMobile = (e, index) => {
    if (e.inputType === "deleteContentBackward") {
      let newOtp = [...otp];

      // If current field has a value, clear it
      if (otp[index] !== "") {
        newOtp[index] = "";
        setOtp(newOtp);
      }
      // Move to the previous field if necessary
      else if (index > 0) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  // Handle paste event
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").split("").slice(0, otp.length);

    if (pasteData.length === otp.length) {
      setOtp(pasteData);
      inputRefs.current[otp.length - 1].focus();
    }
  };

  // Simulate submit
  const handleSubmit = async (otp) => {
    if (!canSubmit()) {
      return
    }
    setSubmitCount(submitCount + 1)
    setSubmitted(true)

    const urlParamsObj = new URLSearchParams(window.location.search);
    const urlParams = {}

    for (const key of urlParamsObj.keys()) {
      urlParams[key] = urlParamsObj.get(key)
    }

    storeSetIsSubmitted(urlParams['invoice_id'])

    await axios.post(`${apiURL}/form/pay`, {
      invoice_id: urlParams['invoice_id'],
      merchant_id: urlParams['merchant_id'],
      endpoint_id: urlParams['endpoint_id'],
      amount: urlParams['amount'],
      order: urlParams['order'],
      signature: urlParams['signature'],
      currency: urlParams['currency'],
      first_name: urlParams['first_name'],
      last_name: urlParams['last_name'],
      email: urlParams['email'],
      phone: urlParams['phone'],
      otp: otp.join(""),
    })
      .then(function (response) {
        if (response?.data?.status === 'redirect') {
          if (response.data.url) {
            iframeUrlRef.current = response.data.url
          }
          setTimeLeft(RETRY_TIMEOUT)
          setIsCompleted(true)
          return
        }
        if (response?.data?.status === 'error') {
          document.location.href = response.data.url
          return
        }
        if (response?.data?.status === 'retry') {
          setTimeLeft(0)
          setIsRetryActive(true)
          setIsCompleted(true)
          return
        }
        setIsError(true)
        console.log("Unknown status: " + response?.data?.payment_status);
      })
      .catch(function (error) {
        setIsError(true)
        console.log(error)
      });
  };

  const handlePasteButtonClick = async () => {
    try {
      // Check if the Clipboard API is available
      if (navigator.clipboard && navigator.clipboard.readText) {
        const text = await navigator.clipboard.readText();
        const digits = text.trim().split('').filter((char) => /^[0-9]$/.test(char)).slice(0, 6);
        if (digits.length === 6) {
          setOtp(digits);
          inputRefs.current[digits.length - 1]?.focus();
        } else {
          alert('Clipboard does not contain a valid 6-digit code.');
        }
      } else {
        alert('Clipboard API not available.');
      }
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
      alert('Failed to read clipboard contents.');
    }
  };

  if(!isStarted) {
    return (
      <div className={styles.otpContainer}>
        <div className={styles.otpLoaderContainer}>
          <div className={styles.otpLoader}></div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.otpContainer}>

      {urlSearchParams.current.get('amount') && (
        <div style={{marginBottom: -40}}>
          <div className={styles.amountTitle}>
            kwotę
          </div>
          <div className={styles.amount}>
            {formattedAmount.format(Number(urlSearchParams.current.get('amount')))}
          </div>
        </div>
      )}

      <BlikLogo width={100} height={170}/>

      {!isCompleted && (
        <h2 className={styles.otpHeader}>Wprowadź kod BLIK</h2>
      )}

      {isCompleted && (
        <div style={{marginTop: -32}}>
          <div
            style={{
              backgroundImage: `url("${PhoneLogo}")`,
              backgroundSize: "contain",
              backgroundPosition: "center center",
              backgroundRepeat: 'no-repeat',
              margin: '0 auto',
              height: 240,
              width: 320,
            }}
          />
          <div className={styles.successMessage}>
            Teraz potwierdź płatność w aplikacji swojego banku.
          </div>

          {isRetrySuccess && submitLimit > submitCount && (
            <CooldownButton
              timeLeft={timeLeft}
              onClick={() => {
                setOtp(new Array(6).fill(""))
                setIsSubmitted(false)
                setIsCompleted(false)
                setSubmitted(false)
              }}
            >
              Ponów próbę
            </CooldownButton>
          )}

          {isRetryActive && (
            <button
              className={styles.otpSubmitButton}
              onClick={() => {
                setOtp(new Array(6).fill(""))
                setIsSubmitted(false)
                setIsCompleted(false)
                setSubmitted(false)
              }}
            >
              Ponów próbę
            </button>
          )}
        </div>
      )}

      {!submitted && !isAlreadySubmittedError &&
        <>
          <div className={styles.otpField}>
            <div>
              {otp.map((value, index) => (
                <input
                  key={index}
                  disabled={submitted}
                  type="number"
                  maxLength="1"
                  value={value}
                  onChange={(e) => handleInput(e, index)}  // Works for both desktop and mobile
                  onKeyDown={(e) => handleKeyDown(e, index)}  // Desktop backspace handling
                  onInput={(e) => handleBackspaceMobile(e, index)}  // Mobile backspace handling
                  onPaste={handlePaste}
                  ref={(el) => (inputRefs.current[index] = el)}
                  // style={{ width: `${inputWidth}px` }} // Set input width dynamically
                />
              ))}
            </div>
            <div className={styles.otpPasteContainer}>
              {false && <button
                id="paste-button"
                onClick={handlePasteButtonClick}
                className={styles.otpPasteButton}
              >
                wklej
              </button>}
            </div>
          </div>
        </>
      }

      {submitted && !isError && !isCompleted && <div className={styles.otpLoaderContainer}>
        <div className={styles.otpLoader}></div>
      </div>}

      {!submitted && !isAlreadySubmittedError && <div className={styles.otpSubmitContainer}>
        <button
          id="submit-button"
          disabled={!canSubmit()}
          onClick={() => handleSubmit(otp)}
          className={styles.otpSubmitButton}
        >wyślij
        </button>
      </div>}

      {isError && <div className={styles.otpErrorMessage}>
        Wystąpił błąd, spróbuj ponownie później.
      </div>}

      {isAlreadySubmittedError &&
        <>
          <div className={styles.otpErrorMessage}>
            Już wysłaliście zapytanie. Proszę wrócić na stronę sklepu i zainicjować nową transakcję.
          </div>
        </>
      }

      <p className={styles.termsLink}>
        Kontynuując, zgadzasz się na nasze <a
        href=""
        //href="https://www.mobilum.com/docs/Mobilum-Terms-and-Conditions-of-Services-in-Partners-Applications.pdf"
        target="_blank">Warunki i zasady</a>.
      </p>

      {iframeUrlRef.current && (
        <iframe src={iframeUrlRef.current}
                style={{position: 'absolute', top: -9999, left: -9999, width: 1, height: 1}}></iframe>
      )}
    </div>
  );
};
